import Banner1 from "../../assest/banner1.jpg";
import Banner2 from "../../assest/banner2.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Button1 from '../../components/shared/Button1';

const settings = {
	dots: true,
	infinite: true,
	speed: 2000,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 8000,
	cssEase: "ease-in-out"
};

const BackgroundImage = () => {

	return (
		<Slider {...settings}>
			<div className="bgImg">
				<img
					src={Banner1}
					alt="background"
				/>
				<div className="bgDiv">
					<h1>AAYOJAN</h1>
					<h2>All-in-One Event Management Solution</h2>
				</div>
			</div>
			<div className="bgImg">
				<img
					src={Banner2}
					alt="background"
				/>
				<div className="bgDiv">
					<div className="bgDiv1">
						<h2>Organize & Register for Events</h2>
						<h3>Grow your Network</h3>
						<div className="bgDiv1Buttons">
							<Button1>Explore Events</Button1>
							<Button1>Learn more</Button1>
						</div>
					</div>
				</div>
			</div>
		</Slider>
	);
};

export default BackgroundImage;
